module.exports = __webpack_public_path__ + "img/clogo.51d30f45.png";